import { render } from "./BaseLottie.vue?vue&type=template&id=59865687"
import script from "./BaseLottie.vue?vue&type=script&lang=js"
export * from "./BaseLottie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__